import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/audit.json';
import ar from './i18n/ar/audit.json';

registerFeatureI18n('adminAudit', { en, ar });

export { AuditPage } from './AuditPage';
export { AuditTable } from './AuditTable';
export { listAuditLogs } from './api';
export type {
  AdminAuditLog,
  AdminAuditLogList,
  ListAuditLogsParams,
} from './api';
